import React, { useState, useEffect } from "react"
import Button from "components/Button"
import { useActions } from "store/utils"
import {
  addToGarage,
  fetchGarage,
  removeFromGarage,
} from "store/garage/actions"
import { addToSearch } from "store/search/actions"

import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { storeIntent } from "store/app/actions"
import GarageFetcher from "./GarageFetcher"
import { isReactEnvironment } from "utils"

import { ReactComponent as KeySVG } from "assets/Icon/Key.svg"

import "./DetailSidebar.sass"

function useCarData() {
  const [carData, setCarData] = useState({})

  useEffect(() => {
    const dataElement = document.getElementById("car_data")
    if (dataElement) {
      const data = JSON.parse(dataElement.textContent)

      Object.keys(data).forEach((key) => {
        if (data[key] === "True") {
          data[key] = true
        } else if (data[key] === "False") {
          data[key] = false
        }
      })

      setCarData(data)
    }
  }, [])

  return carData
}

function Actions({ children }) {
  const actions = useActions({
    fetchGarage: () => fetchGarage(),
    addToGarage: (entry) => addToGarage(entry),
    removeFromGarage: (id) => removeFromGarage(id),
    addToSearch: (payload) => addToSearch(payload),
    storeIntent: (action, payload) => storeIntent(action, payload),
  })

  const carData = useCarData()

  useEffect(() => {
    carData.vin && actions.addToSearch(carData)
  }, [actions, carData])

  const {
    entries,
    isLoaded: isGarageLoaded,
    isLoading: isGarageLoading,
  } = useSelector((state) => state.garage)

  const { authenticated } = useSelector((state) => state.app)

  const navigate = useNavigate()
  function redirect(to) {
    if (isReactEnvironment) {
      navigate(to)
    } else {
      window.location.pathname = to
    }
  }

  if (!children) return false

  async function handleParking(e) {
    e.preventDefault()

    if (authenticated) {
      await actions.fetchGarage()
      await actions.addToGarage(carData)
      redirect("/moja-garaza/")
    } else {
      await actions.storeIntent("ADD_TO_GARAGE", carData)
      redirect("/moja-garaza/")
    }
  }

  async function handleUnparking(e) {
    e.preventDefault()

    if (authenticated) {
      await actions.fetchGarage()
      const entry = entries.find((en) => en.vin === carData.vin)
      if (entry) await actions.removeFromGarage(entry.id)
    }
  }

  async function handleContract() {
    await actions.storeIntent("MAKE_CONTRACT", carData)
    redirect(`/kupoprodajna-pogodba/`)
  }

  const isParkingDisabled =
    (authenticated && !isGarageLoaded) || isGarageLoading
  const isParked = entries.find((e) => e.vin === carData.vin)

  return (
    <>
      <GarageFetcher />
      {children({
        authenticated,
        isParkingDisabled,
        isParked,
        isGarageLoaded,
        handleParking,
        handleUnparking,
        handleContract,
      })}
    </>
  )
}

export function DetailActions() {
  return (
    <Actions>
      {({
        authenticated,
        isParked,
        isParkingDisabled,
        isGarageLoaded,
        handleParking,
        handleUnparking,
        handleContract,
      }) => (
        <div className="DetailActions">
          {!isParked ? (
            <Button onClick={handleParking} disabled={isParkingDisabled}>
              Parkiraj v garažo
            </Button>
          ) : (
            <Button onClick={handleUnparking} disabled={isParkingDisabled}>
              Umakni iz garaže
            </Button>
          )}
          <Button onClick={handleContract}>Izdelaj pogodbo</Button>
        </div>
      )}
    </Actions>
  )
}

export default function DetailSidebar() {
  return (
    <Actions>
      {({
        authenticated,
        isParked,
        isParkingDisabled,
        isGarageLoaded,
        handleParking,
        handleUnparking,
        handleContract,
      }) => (
        <div className="detail-sidebar">
          {!isParked ? (
            <div className="pane">
              <h3>Vaše vozilo?</h3>
              <p>
                V Garaži lahko dostopate do vseh svojih vozil in v zvezi z njimi
                pridobljenimi podatki.
              </p>

              <Button onClick={handleParking} disabled={isParkingDisabled}>
                Parkiraj v garažo
              </Button>
            </div>
          ) : (
            <div className="pane">
              <h3>
                Vozilo v garaži <KeySVG className="safe" />
              </h3>
              <p>Če niste več lastnik vozila, ga lahko umaknete iz garaže.</p>

              <Button onClick={handleUnparking} disabled={isParkingDisabled}>
                Umakni iz garaže
              </Button>
            </div>
          )}

          <div className="pane">
            <h3>Imate kupca?</h3>
            <p>V treh korakih natisnite kupoprodajno pogodbo.</p>

            <Button onClick={handleContract}>Izdelaj pogodbo</Button>
          </div>

          <div className="pane">
            <h3>Nepravilni podatki?</h3>
            <p>Sledite navodilom za posodobitev podatkov vašega vozila.</p>

            <Button href="/posodobitev-podatkov/">Popravi podatke</Button>
          </div>
        </div>
      )}
    </Actions>
  )
}
